import * as React from 'react';
import { Card, Button } from './index';

export const RowCard: React.StatelessComponent<any> = props => (
  <Card bordered={false} bodyStyle={{ padding: 0 }}>
    <h1>{props.name}</h1>
    <Button
      size="large"
      style={{ width: '100%' }}
      icon={props.selected ? 'close' : 'plus'}
      onClick={props.onClick}
      type={props.selected ? undefined : 'primary'}
    >
      {props.buttonText}
    </Button>
  </Card>
);



// WEBPACK FOOTER //
// ./app/components/antd/RowCard.tsx